import { splitProps, type ComponentProps, type JSX } from 'solid-js';

type CardVariant = 'outlined' | 'elevated' | 'subtle' | 'inverse' | 'gradient';
type CardPadding = 'none' | 'sm' | 'md' | 'lg' | 'xl';

interface CardProps extends ComponentProps<'div'> {
  variant?: CardVariant;
  padding?: CardPadding;
  hoverable?: boolean;
}

export function Card(props: CardProps): JSX.Element {
  const [local, rest] = splitProps(props, ['variant', 'padding', 'hoverable', 'class', 'children']);
  return (
    <div
      {...rest}
      class={[
        'tk-card',
        `tk-card--${local.variant ?? 'outlined'}`,
        `tk-card--pad-${local.padding ?? 'lg'}`,
        local.hoverable ? 'is-hoverable' : '',
        local.class ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {local.children}
    </div>
  );
}
